// extracted by mini-css-extract-plugin
export default {"input":"input_component_input__e+3Fc"};